import { useEffect } from 'react';

export const useResizeEffect = (onResize: () => void, deps: any = []) => {
  useEffect(() => {
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
    // eslint-disable-next-line 
  }, [...deps, onResize]);
};